/* eslint-disable */
import HotelEntity from '../Entity/Hotel';
import HotelFactory from '../Factory/Hotel';
import EntityManager from '../EntityManager';
import TourCriteriaObjectValue from '../ObjectValue/TourCriteria';
import AjaxRequestManager from '../AjaxRequestManager';
import hotelToNewFormatAdapter from './service/hotelToNewFormatAdapter';

const HotelsRepository = Backbone.Collection.extend({
	model: HotelEntity,
	addEntry: function (hotels) {
		var hotelsModelsArray,
			entityManager = new EntityManager();

		console.time('renderHotels');
		hotelsModelsArray = entityManager.add({
			factory: HotelFactory,
			repository: repository
		}, hotels);

		this.add(hotelsModelsArray);
		console.timeEnd('renderHotels');
	},
	getParamsForHotelRequest: function (tourCriteria, term, pageType) {
		var params;

		if (tourCriteria instanceof TourCriteriaObjectValue) {
			params = {
				country: tourCriteria.get('countries') ? tourCriteria.get('countries').at(0).get('id') : '',
				resort: tourCriteria.get('resorts') ? tourCriteria.get('resorts').pluck('id') : [],
				hotels: tourCriteria.get('hotels') ? tourCriteria.get('hotels').pluck('id') : [],
				term: term
			}
		} else {
			params = {
				country: tourCriteria.countries ? tourCriteria.countries[0] : '',
				resort: tourCriteria.resorts ? tourCriteria.resorts : [],
				hotels: tourCriteria.hotels ? tourCriteria.hotels : [],
				term: term
			}
		}
		if (pageType === 'ski') {
			let resorts;
			if (tourCriteria instanceof TourCriteriaObjectValue && tourCriteria.get('countries') && tourCriteria.get('countries').length) {
				if (tourCriteria.get('resorts') && tourCriteria.get('resorts').length) {
					resorts = tourCriteria.get('resorts').pluck('id');
				} else {
					resorts = tourCriteria.get('countries').at(0).get('resorts').pluck('id');
				}
				params.resort = resorts;
			}
		}

		params.dc = window.appConfig.showcaseDC;

		return params;
	},
	getHotels: function (data) {
		var params,
			tourCriteria = data.tourCriteria,
			term = data.term ? data.term : null,
			callback = data.callback,
			options,
			pageType = data.pageType,
			ajaxRequestManager = new AjaxRequestManager();

		params = this.getParamsForHotelRequest(tourCriteria, term, pageType);

		options = {
			url: window.appConfig &&  window.appConfig.getHotels ? (window.appConfig.gatewayUrl + window.appConfig.getHotels) : '',
			retriesAvailable: true,
			data: params
		};
		return ajaxRequestManager.getData(options, {
			success: function (hotels) {
				var hotelsCollection = new HotelsRepository(),
					term = data.term ? data.term.toLowerCase() : '';

				hotels = _.map(hotels, (hotel) => hotelToNewFormatAdapter(hotel));

				hotels = _.sortBy(hotels, function (hotel) {
					return hotel.name.toLowerCase().indexOf(term) !== 0;
				});

				hotelsCollection.addEntry(hotels);
				callback && callback.success ? callback.success(hotelsCollection) : '';
			},
			error: function () {
				callback && callback.error ? callback.error() : '';
			}
		});
	}
});

let repository = new HotelsRepository();
HotelsRepository.repository = repository;

export default HotelsRepository;